// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"93":"list","152":"wap","167":"detail","177":"home","312":"wap-detail","640":"wap-list"}[chunkId] || chunkId) + "." + {"93":"f5c78148","152":"07112725","167":"ab813a65","177":"01a5274c","312":"bb09e23b","640":"5598657b","797":"835b8cac"}[chunkId] + ".js";
};